<template>
  <svg
    class="path-layer"
    :viewBox="`0 0 ${design.w} ${design.h}`"
    preserveAspectRatio="none"
    width="100%"
    height="100%"
    aria-hidden="true"
    focusable="false"
  >
    <path
      v-if="d"
      :d="d"
      :stroke="stroke"
      :stroke-width="strokeWidth"
      :style="dashStyle"
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
import { nodesToQuadraticPath } from "@/utils/gameboard-math"

export default {
  name: "PathSVG",
  props: {
    nodes: { type: Array, default: () => [] },
    design: { type: Object, required: true }, // { w, h }
    stroke: { type: String, default: "#ffffff" }, // brand highlight
    strokeWidth: { type: Number, default: 7 },
    dash: { type: Number, default: 16 },       // in design units
    dashed: { type: Boolean, default: true }
  },
  computed: {
    d() { return nodesToQuadraticPath(this.nodes) },
    dashStyle() { return this.dashed ? { strokeDasharray: `${this.dash} ${this.dash}` } : null }
  }
}
</script>

<style scoped>
.path-layer{
  position: absolute;
  inset: 0;
  display: block;       /* avoid inline-SVG 300x150 quirks */
  width: 100%;
  height: 100%;
  pointer-events: none; /* keep UI clickable */
  z-index: 2;
}
</style>
